// import { PipeTransform } from "@angular/core/src/change_detection/pipe_transform";
import { Pipe,PipeTransform } from "@angular/core";


@Pipe({
name:'TeurTashlum'
})
export class TeurTashlumPipe implements PipeTransform{
   
    transform(value: any, tashlumType: string) {

switch(tashlumType) {
    case '2': {
        return "אשראי"
        }
        case '1': {
            return "משכורת"
            }
            default:{
                return "משכורת"
            }
      }
    }    
    
} 